import { Pipe, PipeTransform } from "@angular/core";
import { DoorRef } from "../../../models/shared/refs";

@Pipe({
  name: "doorIdentifier",
  standalone: true,
})
export class DoorIdentifierPipe implements PipeTransform {
  // private permissions = inject(PermissionService);

  transform(value: DoorRef, fullPermission: boolean): string {
    let doorIdentifier = "";

    if (value.location?.label && value.building?.label && value.label) {
      if (fullPermission) {
        doorIdentifier = value.customer?.label
          ? `${value.customer.label} / ${value.location.label} / ${value.building.label} / ${value.label}`
          : `${value.location.label} / ${value.building.label} / ${value.label}`;
      } else {
        doorIdentifier = `${value.location.label} / ${value.building.label} / ${value.label}`;
      }
    }

    return doorIdentifier;
  }
}
